import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { transDistDoConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `transDistDoConfig`. The only page-specific JSX
// is the semicolon/Netto dropzone detail line, passed as the typed
// `dropzoneDetail` slot. Controller renders "admin/trans_dist_do/Uploads".
export default function AdminTransDistDoUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={transDistDoConfig}
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          File harus dipisahkan dengan semicolon (<strong>;</strong>) dan mengandung kolom <strong>Netto</strong>.
        </p>
      }
      {...props}
    />
  )
}
